/**
 * @desc Add plugin description here
 * @usage
 *   1) If using jQuery
 *      $('#dom').priceslider(options)
 *
 *   2) If not using jQuery
 *      var domNode = document.getElementById('dom')
 *      var priceslider = new Priceslider(domNode, options)
 *      priceslider.show() // or any method of the plugin
 *
 *   3) If using HTML-based binding - simple case
 *       <a class="btn" data-priceslider="click" href="http://localhost/bento/iframe.html">Click me</a>
 *
 *   4) If using HTML-based binding - with plugin attributes for example
 *       <button data-priceslider="mouseover" data-animate="true" data-href="#myPriceslider" data-dismiss="false">Mouseover Me</button>
 *
 */
!function(name, module, context) {
	context = context || window
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(typeof window['define'] === 'function') define('widgets/ct_priceslider',['ct_wid'], module)
	else
	//>>excludeEnd("requireTmpl");
		context[name] = module(CT)
}('Priceslider', function(CT) {
	'use strict';
	/**
	 * @desc Append the modal template markup first
	 */
	//if(tmpl) $(document.body).append(tmpl);
	/**
	 * @desc
	 *   This function checks for plugin CSS. If not present, loads automatically from 'stylesheets' folder in your web root.
	 *   If, however, your folder structure is different, you can specify the full css url, as in CT.getCSS('http://path/to/cltp_priceslider.css').
	 *   Or you can add the css for the plugin with a <link> tag in the head of the document. This function need not
	 *   be commented. If the stylesheet is already loaded, it will stop further execution of the function below.
	 */
	//CSS Loader Removed!
	/**
	 * @desc default settings for the Modal component
	 */
	var defaults = {
		state: 'intiliaze',
		step: "100",
		range: "false" // default state of priceslider unless specified by user
		// Add more default options here
	};

	/* ------------------------------------- Private methods below --------------------------------------- */
	/**
	 * @desc Desc of the private method
	 * @return Add return
	 */

	/*function setHandleOverlapLogic($slider, settings){
		var selWidth = $slider.find('.selection').width() || 166 //TODO check why is the width not coming in IE8. Personally I don't care!
		var setData = function($s, s, w){
			if(w === 0) w = $s.find('.selection').width()
			var data = {
				minPriceRange : ((s.max - s.min)/w) * (CT.app.indexOf('hotel') > -1? 13 : 18),  
				minHandleGap : $s.find('a.rangeHandle').width()
			}
			$s.data('antiOverlap', data)
		}
		setData($slider, settings, selWidth)
	}*/
	
	function logarithmicSlider($sliderData, uivalues){
		var gBudgetBottom, gBudgetTop;
		var gMinPrice = $sliderData.min == 0 ? 1 : $sliderData.min;
		var gMaxPrice = $sliderData.max; 

		var expon = function(val){
		    var minv = Math.log(gMinPrice);
		    var maxv = Math.log(gMaxPrice);
		    var scale = (maxv-minv) / (gMaxPrice-gMinPrice);
		    return Math.exp(minv + scale*(val-gMinPrice));
		}
		gBudgetBottom = Number(Number(expon(uivalues[0])).toFixed(0));

		if(gMinPrice != gBudgetBottom){
			gBudgetBottom = Math.round(gBudgetBottom/1000) * 1000;
			if(gMinPrice != 0  && gBudgetBottom /1000 == 0){
				gBudgetBottom = (gMinPrice < gBudgetBottom ) ? gBudgetBottom : gMinPrice;
			}
		}

        gBudgetTop = Number(Number(expon(uivalues[1])).toFixed(0));
        if(gMaxPrice != gBudgetTop){
	        gBudgetTop = Math.round(gBudgetTop/1000) * 1000
		}

		if(gBudgetTop < gBudgetBottom){
			gBudgetTop = gBudgetBottom;
		}

        return [Int(gBudgetBottom),Int(gBudgetTop)];
	}

	function inverseLogSlider($sliderData, uivalues){
		if (!uivalues[0] || !uivalues[1]) {
			return uivalues;
		}
		var min = $sliderData.min
		var max = $sliderData.max
		var minv = Math.log(min);
		var maxv = Math.log(max);
		var logposition = function(val){
		    var scale = (maxv-minv) / (max-min);
		    return (Math.log(val)-minv) / scale + min;
		}
		return [logposition(uivalues[0]), logposition(uivalues[1])];
	}

	/* ------------------------------------- Private methods section ends --------------------------------------- */



	/* ------------------------------------- COMPONENT DEFINITION -------------------------------------------- */

	function Priceslider(el, options) {
		this.el = el;
		this.settings = options;
	}

	Priceslider.prototype = {
		constructor: Priceslider,

		// Add prototype methods
		/**
		 * @desc 'alert' state of the plugin
		 */
		intiliaze: function() {
			var data = this.settings;
			var $el = $(this.el)
			var maxi = Number(data.max);
			var mini = Number(data.min);
			var stepNum = Number(data.step);
			var rangeTrr = data.range;
			var val = data.value;
			var priceUrlParam = CT.cache.tabsMap[CT.settings.currentTab].price;
			var sliderValue;
			if (priceUrlParam) {
				sliderValue = priceUrlParam.split('-');
				console.log("logarithmicSlider(data, sliderValue)", logarithmicSlider(data, sliderValue))
			} else {
				sliderValue = [mini, maxi];
			}
			var that = this;
			var sliderOpts = {
				range: rangeTrr,
				min: mini,
				max: maxi,
				step: stepNum,
				
				slide: function(event, ui) {
					var $handle = $(ui.handle),
						$t = $(event.target),
						$sliderData = $t.data('ct_priceslider')
					
					if(that.settings.name !== "taStarRating" && that.settings.name !== "hrsFilterSlider"){ //TODO
						if(rangeTrr == 'min')
							var priceRange = ui.value;
						else var priceRange = ui.values[1] - ui.values[0]
						if(priceRange <= 0){
							event.preventDefault();
						} else {
							if(CT.app == "hotel" && window.countryCode == "in" && ui.values[1] != 0 && ui.values[0] != 0){
								ui.values = logarithmicSlider($sliderData,ui.values);
							}
							CT.fire('filters.callback', [{
								value: (rangeTrr == 'min' ? [mini, ui.value] : [ui.values[0], ui.values[1]]), //Array
								value1: [ui.value], // Handle value
								name: $sliderData.name,
								ref: event.target
							}]);
						}
					} else
						CT.fire('filters.callback', [{
							value: ui.values,
							value1: [ui.value],
							name: $sliderData.name,
							ref: event.target
						}])

				},

				change: function(event, ui) {
					var $sliderData = $(event.target).data('ct_priceslider')
					var gBudgetBottom, gBudgetTop;
					//ui.values = ui.values || [$sliderData.range === 'min'? ui.value : $sliderData.min, $sliderData.range === 'min'? $sliderData.max : ui.value]
					ui.values = ui.values || [$sliderData.range === 'max'? ui.value : $sliderData.min, $sliderData.range === 'max'? $sliderData.max : ui.value]

					if($sliderData.name == "price" && CT.app == "hotel" && window.countryCode == "in" && ui.values[1] != 0 && ui.values[0] != 0){
						ui.values = logarithmicSlider($sliderData,ui.values);
					}

					if(ui.trigger !== false) { // only when triggerValue is set trigger its custom event
						CT.fire(($sliderData.fire ? $sliderData.fire : 'sliderMoved'), [{
							value: (rangeTrr == 'min' ? [mini, ui.value] : ui.values) ,
							value1: ui.value,
							name: $sliderData.name,
							ref: event.target
						}]);
					}
					CT.fire('filters.callback', [{
						value: (rangeTrr == 'min' ? [mini, ui.value] : ui.values) ,
						value1: [ui.value],
						name: $sliderData.name,
						ref: event.target
					}])
				}
			};
			if (rangeTrr == 'min') {
				sliderOpts.value = val
			} else {
				sliderOpts.values = inverseLogSlider(data, sliderValue)
			}
			$el.slider(sliderOpts); // slider initializer ends
			CT.fire('filters.callback', [{
				value: sliderValue,
				value1: [data.min],
				name: data.name,
				ref: this.el
			}])

			//setHandleOverlapLogic($el, data)
		}
	}

	function execPriceslider(e, data) {
		e && e.preventDefault();
		data = data || $(this).data('ct_priceslider');
		new Priceslider(this, data)[data.state]();
	} /* -------------------------------------------------------------------------------------------------------------- */


	// Manual binding - when user calls the plugin via javascript
	$.fn[$.fn.priceslider ? 'ctpriceslider' : 'priceslider'] = function(options) {
		return this.each(function() {
			var $elem = $(this),
				htmlSettings = $elem.data('ct_priceslider'),
				settings = {};

			if(!htmlSettings) $elem.data('ct_priceslider', (htmlSettings = CT.getHTMLSettings(this))); // check and store plugin settings from HTML attrs
			if(typeof options === 'string') settings.state = options; // If user sends a string (instead of hash) defining state of the plugin
			$.extend(settings, defaults, htmlSettings, typeof options === 'object' && options);
			$elem.data('ct_priceslider', settings);
			execPriceslider.call(this, undefined, settings);
		});
	};

	// Auto binding
	$('[data-priceslider]').each(function() {
		var $elem = $(this),
			evt = $elem.attr('data-priceslider') || 'click';
		$elem.data('ct_priceslider', $.extend({}, defaults, CT.getHTMLSettings(this))).bind(evt, execPriceslider);
		execPriceslider.call(this);
	});

	return Priceslider;
}, CT)
;
